import { createPinia, setActivePinia } from "pinia";
import i18n from "@shared/locale/i18n.js";
import {
  configCsrfToAxios,
  initializeInstances,
} from "@shared/services/initializer.js";
import { useCurrentMember } from "@shared/composables/members/use-current-member";
import { useFetchCountries } from "@shared/composables/countries/use-fetch-countries";

export class Initializer {
  constructor() {
    this.vueApps = [];
    this.pinia = createPinia();
    this.start();
  }

  async start() {
    configCsrfToAxios();
    setActivePinia(this.pinia);

    try {
      const { initCurrentMember } = useCurrentMember();
      initCurrentMember();
    } catch (error) {
      console.error("[main initializer] initCurrentMember failed:", error);
    }
    const { fetchAllCountries } = useFetchCountries();
    fetchAllCountries();

    initializeInstances({
      pinia: this.pinia,
      i18n,
      vueApps: this.vueApps,
      importInitializer: (vueName) => import(`./initializers/${vueName}.js`),
      pageScope: "main",
    });
  }
}

export default Initializer;
